import { MEDIA_SERVICE } from '../steps/CardDesign/config';
import { isUrlWithHttpProtocol } from '@shared/utils/urlHelpers';

const MINIMUM_PPI = 150;
export const SCALE_MAX = 72 / MINIMUM_PPI;

export const previewUrls = new Map<string, string>();

export function absolutePhotoUrl(imageLayerSrc: string) {
  if (isUrlWithHttpProtocol(imageLayerSrc)) {
    return imageLayerSrc;
  }

  return imageLayerSrc.includes('/') ? `${MEDIA_SERVICE}/${imageLayerSrc}` : `https://withjoy.com/media/paper/${imageLayerSrc}`;
}
